import { createGlobalStyle } from "antd-style";
import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const GlobalBody = createGlobalStyle`
  :root {
    color-scheme: light dark;
    color: ${variableColors["ColorFigmaNeutralGrayscaleGray90"]};
    background-color: ${variableColors["ColorFigmaNeutralWhiteWhite100"]};
    font-family: ${variableTypography["BodyMediumFontFamily"]};
    
    text-rendering: geometricPrecision;
    font-synthesis: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    margin: 0;
    max-width: 100vw;
    min-height: 100vh;
    padding: 0;
    overflow-x: hidden;
  }

  * {
    font-family: ${variableTypography["BodyMediumFontFamily"]};
  }

`;
